import React, { FC, useEffect, useRef } from "react";
import { WithStyle } from "utils/WithStyle";
import { useKeyPress } from "utils/useKeyPress";
import Content from "./Content";
import Footer from "./Footer";
import Header from "./Header";
import { InnerWrapper, ModalContainer } from "./Modal.styled";
import { ModalProps, ModalStaticProps } from "./types";

const Component: FC<ModalProps> = ({ isOpen, onClose, children, asForm }) => {
    const isEscapePressed = useKeyPress("Escape", false);
    const modalRef = useRef<HTMLDivElement | null>(null); // Ref for the modal container

    useEffect(() => {
        if (isOpen && isEscapePressed) {
            onClose();
        }
    }, [isEscapePressed, isOpen, onClose]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.height = "100vh";
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.height = "unset";
            document.body.style.overflow = "unset";
        }
    }, [isOpen]);

    return (
        <ModalContainer {...(asForm ? { as: "form" } : {})} isOpen={isOpen}>
            <div ref={modalRef}>
                <InnerWrapper>{children}</InnerWrapper>
            </div>
        </ModalContainer>
    );
};

export const Modal: FC<ModalProps> & WithStyle & ModalStaticProps =
    Object.assign(Component, {
        Style: ModalContainer,
        Header,
        Content,
        Footer,
    });